import { Controller } from "@hotwired/stimulus"

// Prevents double-submission of resend OTP form
export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.isSubmitting = false
  }

  preventDoubleSubmit(event) {
    // Prevent double submission
    if (this.isSubmitting) {
      event.preventDefault()
      return
    }

    // Mark as submitting
    this.isSubmitting = true

    // Disable the button immediately
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = true
      this.buttonTarget.classList.add("opacity-50", "cursor-not-allowed")
    }

    // Allow form to submit naturally
  }
}
